import { render, staticRenderFns } from "./MessengerColletion.vue?vue&type=template&id=ee5a1284&scoped=true"
import script from "./MessengerColletion.vue?vue&type=script&lang=js"
export * from "./MessengerColletion.vue?vue&type=script&lang=js"
import style0 from "./MessengerColletion.vue?vue&type=style&index=0&id=ee5a1284&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee5a1284",
  null
  
)

export default component.exports